import { useState } from 'react'
import { LaunchDarkly } from '@truepill/tpos-types'
import { ReactComponent as PeopleIcon } from 'assets/icons/people.svg'
import IconWrapper from 'components/IconWrapper'
import MultiSelect from 'components/MultiSelect'
import { useFlag } from 'providers/LaunchDarklyProvider'
import { useTPCacheContext } from 'providers/TPCacheProvider'
import { usePlusClient } from 'providers/VisionRouter'

type CustomerSelectProps = {
  label?: string
  variant?: 'small' | 'large'
}

const CustomerSelect = (props: CustomerSelectProps): JSX.Element => {
  const displayDashboardDesignV2: boolean = useFlag(LaunchDarkly.FeatureFlags.TPOS_DASHBOARD_DESIGN_V2) ?? false

  const { variant = 'large' } = props
  const { currentLocation, routeToMergedQuery } = usePlusClient()
  const { customers } = useTPCacheContext()

  const [selectedOptions, setSelectedOptions] = useState<string[]>(currentLocation?.queryMap?.customerIds || [])

  const allOption = {
    label: 'All customers',
    value: '',
    selectAll: true,
  }

  const customerOptions = Object.values(customers)
    .map(value => ({
      label: value.name,
      value: value._id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
    .sort((a, b) =>
      selectedOptions.includes(a.value) && !selectedOptions.includes(b.value)
        ? -1
        : selectedOptions.includes(b.value) && !selectedOptions.includes(a.value)
        ? 1
        : 0,
    )

  const options = [allOption, ...customerOptions]

  return (
    <MultiSelect
      css={{
        ul: { maxHeight: '21rem' },
        ...(displayDashboardDesignV2 && variant === 'small' && { width: '14rem' }),
      }}
      options={options}
      placeholder="Select customers"
      renderOptions={{ displayQuantity: true }}
      startAdornment={() =>
        displayDashboardDesignV2 ? (
          <IconWrapper>
            <PeopleIcon fill={'black'} />
          </IconWrapper>
        ) : (
          <></>
        )
      }
      value={selectedOptions}
      variant={variant}
      onChange={values => {
        setSelectedOptions(values)
        if (values.includes(allOption.value)) {
          routeToMergedQuery({ customerIds: [] })
        } else {
          routeToMergedQuery({ customerIds: values })
        }
      }}
    />
  )
}

export default CustomerSelect
